<template>
    <div
            id="app"
            class="main-app"
    >
        <component :is="layout">
            <router-view />
        </component>
    </div>
</template>

<script>
const DefaultLayout = () => import("@/layouts/DefaultLayout");

export default {
    name: 'App',

    computed: {
        layout() {
            return this.$route?.meta?.layout || DefaultLayout;
        }
    }
};
</script>

<style lang="scss">
    @import "@/styles/main.scss";
</style>
